import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=8a320834"
import script from "./WishList.ts?vue&type=script&lang=ts&external"
export * from "./WishList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports